import { apiClient } from "./client";
import { ApiResponse } from "../types";

export class TemplateAPI {
  static async getTemplate(
    templateType: string,
    projectId: string
  ): Promise<ApiResponse<any>> {
    return apiClient.get<any>(
      `/template/${encodeURIComponent(
        templateType
      )}?project_id=${encodeURIComponent(projectId)}`
    );
  }
}

export default TemplateAPI;
